/* 카카오 지도 SDK 로더와 장소 검색.
 *
 * SDK 는 전역(window.kakao)으로만 존재한다. import 로 끌어올 방법이 없어서
 * script 태그를 붙이고 한 번만 붙도록 프라미스를 캐시한다.
 */

let pending = null;

export function loadKakao(key) {
  if (pending) return pending;
  pending = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    // services 라이브러리가 있어야 장소 키워드 검색(Places)을 쓸 수 있다.
    script.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${key}&autoload=false&libraries=services`;
    script.onerror = () => reject(new Error("SDK 로드 실패"));
    script.onload = () => window.kakao.maps.load(() => resolve(window.kakao));
    document.head.appendChild(script);
  });
  return pending;
}

export const KAKAO_RADIUS_M = 1000;
export const KAKAO_MAX_PAGES = 3;   // 페이지당 15건, 최대 45건이 SDK 상한

/** 여러 키워드를 각각 검색해 합집합을 낸다. 카카오는 OR 질의를 모르므로 — '한식 + 카페'를
 *  통째로 넘기면 그 문자열 그대로 찾다가 0건이 된다 — 한 번씩 나눠 묻고 우리가 합친다. */
export function keywordSearchAny(places, terms, origin) {
  return Promise.all(terms.map((t) => keywordSearch(places, t, origin))).then((res) => {
    const ids = new Set();
    res.forEach((r) => r.ids.forEach((id) => ids.add(id)));
    // 키워드끼리 겹치는 장소가 있어 total 을 더하면 같은 가게를 두 번 센다. 집합 크기가 답이다.
    return { ids, total: ids.size, truncated: res.some((r) => r.truncated) };
  });
}

/** 반경 안의 장소를 훑어 place_id 집합을 돌려준다. 실패도 유효한 답이므로 reject 하지 않는다. */
export function keywordSearch(places, q, origin) {
  const kakao = window.kakao;
  return new Promise((resolve) => {
    const ids = new Set();
    let total = 0;
    places.keywordSearch(q, (data, status, pagination) => {
      if (status !== kakao.maps.services.Status.OK) {
        // ZERO_RESULT 도 유효한 답이다 — '카카오에도 없다'는 정보.
        return resolve({ ids, total, truncated: false });
      }
      data.forEach((d) => ids.add(String(d.id)));
      total += data.length;
      if (pagination.hasNextPage && pagination.current < KAKAO_MAX_PAGES) pagination.nextPage();
      else resolve({ ids, total, truncated: pagination.hasNextPage });
    }, {
      location: new kakao.maps.LatLng(origin[0], origin[1]),
      radius: KAKAO_RADIUS_M,
      size: 15,
    });
  });
}
